let currentIdIndex = 0;

export default function (prefix = 'id') {
  const id = `${prefix}-${currentIdIndex}`;
  currentIdIndex += 1;

  return id;
}
